import { Redirect, Stack } from 'expo-router'
import { useStore } from '@/models'

export default function () {
  const {
    session: { isAdmin, isSuperAdmin }
  } = useStore()

  if (!isAdmin && !isSuperAdmin) {
    return (
      <Redirect href="/(root)/(tabs)" />
    )
  }

  return (
    <Stack screenOptions={{ headerShown: false }} />
  )
}
